import { Controller } from "@hotwired/stimulus"

// Clipboard controller for copy-to-clipboard functionality
// Usage: data-controller="clipboard" on container, data-action="clipboard#copy" on button
export default class extends Controller {
  static values = {
    text: String
  }

  copy(event) {
    const button = event.currentTarget
    const textToCopy = button.dataset.clipboardText || 
                       this.textValue || 
                       this.element.querySelector("code, pre")?.textContent

    if (!textToCopy) return

    navigator.clipboard.writeText(textToCopy).then(() => {
      // Show success feedback
      const originalContent = button.innerHTML
      button.innerHTML = `
        <svg class="w-5 h-5 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
        </svg>
      `
      button.classList.add("!bg-green-600")

      // Restore original content after 2 seconds
      setTimeout(() => {
        button.innerHTML = originalContent
        button.classList.remove("!bg-green-600")
      }, 2000)
    }).catch(() => {
      // Fallback for older browsers
      const textarea = document.createElement("textarea")
      textarea.value = textToCopy
      textarea.style.position = "fixed"
      textarea.style.left = "-9999px"
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand("copy")
      document.body.removeChild(textarea)
    })
  }
}
